import React from 'react';

import { FORMAT_LABELS, JSON_SCHEMA_FORMATS } from './helpers';
import styles from './schema-editor.module.css';

interface FormatSelectProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
}

/** JSON Schema `format` picker, used for both an attribute and an array's items. */
export const FormatSelect: React.FC<FormatSelectProps> = ({ label, value, onChange }) => (
  <label className={styles.editorField}>
    {label}
    <select value={value} onChange={event => onChange(event.target.value)}>
      <option value="">None</option>
      {JSON_SCHEMA_FORMATS.map(schemaFormat => (
        <option key={schemaFormat} value={schemaFormat}>
          {FORMAT_LABELS[schemaFormat]}
        </option>
      ))}
    </select>
  </label>
);
